<template>
  <div class="PaintingDetail">
    <img
      class="shadow"
      :src="require(`@/assets/images/${paintings[0].imageName}`)"
    />

    <div class="right-align">
      <div class="TextBox" v-if="!showContact">
        <h1>
          <b>{{ paintings[0].title }}</b>
        </h1>
        <p>{{ paintings[0].description }}</p>
        <i>Målad av Maria Ivarsson</i>
      </div>
      <Contact v-if="showContact" />
      <div class="buttonWrapper">
        <button v-if="!showContact" v-on:click="showContact = !showContact">
          Köp tavlan
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from '@/Components/Contact.vue';

export default {
  setup() {},
  components: {
    Contact,
  },
  data() {
    return {
      showContact: false,
      paintings: [
        {
          id: 0,
          imageName: 'tree-tops.jpg',
          title: 'Trädens grönska',
          description:
            'En kort beskrivande text som kanske förklarar något En kort beskrivande text som kanske förklarar något En kort beskrivande text som kanske förklarar något En kort beskrivande text som kanske förklarar något',
        },
        {
          id: 1,
          imageName: 'beach.jpg',
          title: 'Strandeeeeen!',
          description: 'En kort beskrivande text som kanske förklarar något',
        },
        {
          id: 2,
          imageName: 'garden.jpg',
          title: 'Rosor är röda, violer är blå',
          description: 'En kort beskrivande text som kanske förklarar något',
        },
        {
          id: 3,
          imageName: 'portrait.jpg',
          title: 'Test!',
          description: 'En kort beskrivande text som kanske förklarar något',
        },
        {
          id: 4,
          imageName: 'studio.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
        {
          id: 5,
          imageName: 'tomato-field.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
        {
          id: 6,
          imageName: 'tree-tops.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
        {
          id: 7,
          imageName: 'tree-tops.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
        {
          id: 8,
          imageName: 'tree-tops.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
        {
          id: 9,
          imageName: 'tree-tops.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
        {
          id: 10,
          imageName: 'tree-tops.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
        {
          id: 11,
          imageName: 'tree-tops.jpg',
          title: 'Test!',
          description: 'Wooow!',
        },
      ],
    };
  },
};
</script>

<style scoped>
.PaintingDetail {
  margin: 3%;
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  width: 50vw;
  max-width: 500px;
  height: 80vw;
  max-height: 80vh;
  object-fit: cover;
  transition: 0.3s;
  size: 1;
}

.TextBox {
  max-width: 500px;
  min-width: 300px;
  padding: 1%;
}

h1 {
  margin-top: 0;
}

button {
  margin: auto;
}

.right-align {
  margin-left: 3%;
}

i {
  font-size: 10px;
}
</style>
